import { format } from 'date-fns'
import { Prescription } from '../../types'

export const transformPrescriptions = (prescription: Prescription) => {
  const {
    id,
    scid,
    createdDate,
    prescribedItems,
    isPaperPrescription,
    issueSnapshot: { patient, prescriber, location },
  } = prescription

  return {
    id,
    patientName: `${patient?.givenNames ?? ''} ${patient?.familyName ?? ''}`,
    prescriberName: `${prescriber?.givenNames ?? ''} ${prescriber?.familyName ?? ''}`,
    locationName: location?.name ?? '',
    scid,
    createdDate: format(new Date(createdDate), 'yyyy-MM-dd'),
    prescribedItems: prescribedItems.map(
      ({ genericName, quantity, state, patientInstructions, numberOfRepeatsAuthorised }) => ({
        displayName: `${genericName} | Qty: ${quantity}`,
        state,
        patientInstructions,
        numberOfRepeatsAuthorised,
      })
    ),
    isPaperPrescription,
    isEmergencySupply: prescribedItems.some((drug) => drug.emergencySupply),
    isSendToPharmacy: prescribedItems.some(
      (drug) => drug.sendToPharmacy && drug.sendToPharmacy !== ''
    ),
  }
}
